import { ResidentMedicationsTemplate } from "app/features/medications/templates/ResidentMedicationsTemplate";

export default function MedicationHistoryPage() {
  return <ResidentMedicationsTemplate />;
}
